<div class="content">
  @if (label) {
    <label>{{ label }}</label>
  }
  <div class="input-section">
    @if (inactiveLabel) {
      <h6 [ngClass]="{ bold: !isChecked }">{{ inactiveLabel }}</h6>
    }
    <div class="switch" [ngClass]="{ disabled: disabled }">
      <input type="checkbox" [checked]="value" [id]="'ckb-' + id" [disabled]="disabled" class="switch-checkbox" (input)="onChange($event)" />
      <label class="switch-label" [for]="'ckb-' + id" [ngClass]="[offColor === 'red' ? 'red-bg-color' : '', defaultView ? 'default-status' : '']">
        <span class="switch-inner" [ngClass]="onColor === 'green' ? 'green-bg-color' : 'blue-bg-color'"> </span>
        <span class="switch-switch" [ngClass]="onColor === 'green' ? 'green-bg-color' : 'blue-bg-color'"></span>
      </label>
    </div>
    @if (activeLabel) {
      <h6 [ngClass]="{ bold: isChecked }">{{ activeLabel }}</h6>
    }
  </div>
</div>
